import * as React from 'react';
import { InfoLine } from './InfoLine';
export var ReferenceText = function (_a) {
    var referenceText = _a.referenceText;
    return referenceText ? (React.createElement(InfoLine, { dataHook: "reference-text" }, referenceText)) : null;
};
//# sourceMappingURL=ReferenceText.js.map